@if (warranty) {
  <div class="container single-view" id="edit-warranty">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" href="javascript:void(0)" appBack [fallbackUrl]="'/warranties/' + warrantyId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'WARRANTIES.BTN_BACK_TO_WARRANTY' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-warranty-title" class="section-title">{{ 'WARRANTY_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="warrantyForm" data-testid="edit-warranty-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 class="border-b pb-3">{{ 'WARRANTY_UPDATE.WARRANTY_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                    <div class="row">
                      <div class="col-12">
                        <label data-testid="edit-warranty-field-code" class="text-sm" for="type">{{ 'WARRANTY_UPDATE.CODE' | translate }}</label>
                        <input data-testid="edit-warranty-code-input" type="text" formControlName="code" autocomplete="off">
                      </div>
                    </div>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                    <div class="row">
                      <div class="col-12">
                        <label data-testid="edit-warranty-field-item" class="text-sm" for="type">{{ 'WARRANTY_UPDATE.ITEM_ID' | translate }}</label>
                        <input data-testid="edit-warranty-item-input" type="text" id="type" formControlName="itemId" autocomplete="off">
                      </div>
                    </div>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                    <label data-testid="edit-warranty-field-activationdate" class="block text-sm" for="date">{{ 'WARRANTY_UPDATE.ACTIVATION_DATE' | translate }}</label>
                    <p-datepicker data-testid="edit-warranty-activationdate-input" class="w-100" formControlName="activationDate" dateFormat="dd-mm-yy" [maxDate]="currentDate" placeholder="{{ 'WARRANTY_UPDATE.DATE_PLACEHOLDER' | translate }}" showIcon="true" [showTime]="true" appendTo="body" />
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                    <label data-testid="edit-warranty-field-enddate" class="block text-sm" for="date">{{ 'WARRANTY_UPDATE.END_DATE' | translate }}</label>
                    <p-datepicker data-testid="edit-warranty-enddate-input" class="w-100" formControlName="endDate" dateFormat="dd-mm-yy" [maxDate]="currentDate" placeholder="{{ 'WARRANTY_UPDATE.DATE_PLACEHOLDER' | translate }}" showIcon="true" [showTime]="true" appendTo="body" />
                  </div>
                  @if (companyIsPrepaired) {
                    <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                      <div class="row">
                        <div class="col-12">
                          <span class="label text-sm">{{ 'WARRANTY_UPDATE.PRE_PAIRED' | translate }}</span>
                          <span class="inline-flex mr-6">
                            <p-radioButton name="isPrepaired" value="true" formControlName="isPrepaired" inputId="yes" />
                            <label for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</label>
                          </span>
                          <span class="inline-flex mr-2">
                            <p-radioButton name="isPrepaired" value="false" formControlName="isPrepaired" inputId="no" />
                            <label for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</label>
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-warranty-update-warranty-button"  class="btn primary-btn" [disabled]="warrantyForm.invalid" (click)="submitForm()">{{ 'WARRANTY_UPDATE.BTN_UPDATE_WARRANTY' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
